<template>
  <div class="container">
    <CommonFrame :workNo="workNo"
                  :btns="btns"
                  :node="node"
                  :moduleName="moduleName"
                  :breadcrumb="breadcrumb"
                  :endStatus="approvalParams.endStatus"
                  :approvalTabStatus="approvalParams.approvalTabStatus"
    >
      <div slot="info">
        <h4>
          <span>报损单号:</span>
          <span>{{id}}</span>
        </h4>
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="tableInfo">
        <div class="cardContainer">
          <lk-card title="报损信息">
            <lk-table border :columns='columns' :data='tableData'></lk-table>
          </lk-card>
        </div>
      </div>
    </CommonFrame>
  </div>
</template>

<script>
import axios from 'axios';
import CommonFrame from '../commonFrame.vue';
import utils from '../../../libs/utils';

export default {
  name: 'Breakage',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
  },
  data() {
    return {
      workNo: '',
      node: '',
      moduleName: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
        {
          name: 'approvalEdit',
          title: '报损审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
      columns: [],
      tableData: [],
      id: '',
      idText: '',
    };
  },
  methods: {
    getBreakageInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        const tempColumns = res.data.data.columns;
        tempColumns.forEach((item) => {
          this.columns.push({ title: item.title, key: item.key, minWidth: 116 });
        });
        this.tableData = res.data.data.tableData;
        this.id = res.data.data.id.toString();
        this.idText = res.data.data.idText;
        this.infosArr = res.data.data.infos;
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;
    this.getBreakageInfo(this.approvalParams.businessUrl);
  },
};
</script>
